module.exports = __webpack_public_path__ + "static/media/logo.39ddba4c.png";